import styled from 'styled-components';
import { IconButton } from '@arcadiapower/design-system';
import { ty } from '@client/styles/typography';

export const ConnectContainerWrapper = styled.div`
  max-width: 500px;
  margin: auto;
  display: flex;
  flex-direction: column;

  height: 100%;
`;

export const StyledHeader = styled.div<{
  $hasBackButton?: boolean;
}>`
  display: grid;
  grid-template-areas: ${({ $hasBackButton }) =>
    $hasBackButton ? "'back title close'" : "'title close'"};
  grid-template-columns: ${({ $hasBackButton }) => ($hasBackButton ? '32px 1fr 32px' : '1fr 32px')};
  grid-template-rows: 32px;
  align-items: center;
  border-bottom: 1px solid var(--border-primary);
  padding: 24px;
  height: 80px;
  gap: 10px;
`;

export const Title = styled.h2.attrs({
  className: ty('dialogTitle'),
})<{ $flushLeft?: boolean }>`
  flex-grow: 1;
  grid-row: 1;
  grid-column: title;
  text-align: ${({ $flushLeft }) => ($flushLeft ? 'left' : 'center')};
`;

export const BackButton = styled(IconButton)`
  grid-column: back;
  grid-row: 1;
`;

export const ContentSection = styled.div<{
  withTopPadding?: boolean;
  withBottomPadding?: boolean;
  centerContentVertically?: boolean;
  centerContentHorizontally?: boolean;
}>`
  padding-left: 24px;
  padding-right: 24px;

  ${props =>
    props.withBottomPadding &&
    `
    padding-bottom: 32px;
  `}

  ${props =>
    props.withTopPadding &&
    `
    padding-top: 32px;
  `}

  ${props =>
    (props.centerContentVertically || props.centerContentHorizontally) &&
    `
    display: flex;
    height: 100%;
  `}

  ${props =>
    props.centerContentVertically &&
    `
    justify-content: center;
  `}

  ${props =>
    props.centerContentHorizontally &&
    `
    align-items: center
  `}
`;

ContentSection.defaultProps = {
  withBottomPadding: true,
  withTopPadding: true,
};

export const ContentSectionFullHeight = styled(ContentSection)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
`;

export const Footer = styled.div`
  padding: 24px;
  align-self: flex-bottom;
  border-top: 1px solid var(--border-primary);
  height: auto;
`;
